var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('div',{staticClass:"overlayDiv",style:('width:' + _vm.canvas.width + 'px')},[_c('canvas',{staticStyle:{"border":"2px dashed #ffffff"},attrs:{"id":"canvas","width":_vm.canvas.width,"height":_vm.canvas.height}})])])}
var staticRenderFns = []

export { render, staticRenderFns }